module.exports = __webpack_public_path__ + "img/ac64674d1a450f8c9e607fa63c3a0816.png";